<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="header text-center">
            <h4 class="title">Create New User</h4>
          </div>
          <create-user-form />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import CreateUserForm from './Users/CreateUserForm.vue'

  export default {
    components: {
      CreateUserForm,
    }
  }

</script>
<style>

</style>
